<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
    <el-tab-pane name="xjyazd">
      <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 巡检预案制定 </span>
      <normalNav :parent="self">
        <cell _tag="button" class="GreenSmBtn" @click="add">新增</cell>
      </normalNav>
      <div class="searchForm1">
        <searchForm :items="items" :formPlus="form_xjyazd" ref="searchForm_xjyazd">
          <template slot="last">
            <el-form-item label="巡检部门" prop="dept_id">
              <searchCompany :pId="form_xjyazd.dept_id" @changeCompany="changeCompany" ref="searchCompany"></searchCompany>
            </el-form-item>
          </template>
        </searchForm>
      </div>
      <div class="tableWrapper">
        <easyTable apiUrl="operation/plan/findAll" :parent="self" :config="config" :other="other" ref="table_xjyazd">
          <template slot="last">
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="look(scope.row)">详情</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>

      <add :pVisible="addDialogVisible" @closeAdd="addDialogVisible=false" @success="success"></add>

      <el-dialog class="lookDialog" title="预案详情" :visible.sync="lookDialogVisible" :close-on-click-modal="false" v-loading="lookLoading">
        <section class="list" v-if="!lookLoading">
          <ul>
            <li>预案名称：{{oLook.name}}</li>
            <li>巡检最长时长(小时)：{{oLook.max_time}}</li>
            <li>巡检最短时长(小时)：{{oLook.min_time}}</li>
          </ul>
          <ul>
            <li>巡检间隔时间(分钟)：{{oLook.interval_time}}</li>
            <li>巡检部门：{{oLook.deptName}}</li>
            <li>是否顺序巡检：{{oLook.sequence == 0 ? "是" : "否"}}</li>
          </ul>
        </section>
        <header class="point"><span>点位详情</span></header>
        <easyTable :pData="{
    data:oLook.list,
    nTotal:oLook.list.length
  }" :config="col" v-if="!lookLoading">
        </easyTable>
      </el-dialog>

    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  dt,
  obj2urlsp
} from "utils";

export default {
  data() {
    return {
      tabName: 'xjyazd',
      show: false,
      items: [{
        type: "input",
        prop: "name",
        label: "预案名称",
        placeholder: "",
      }],
      form_xjyazd: {},
      oLook: {},
      lookLoading: true,
      lookDialogVisible: false,
      addDialogVisible: false,
      data: {},
      other: {},
      tableData: []
    };
  },
  computed: {
    self() {
      return this;
    },
    col() {
      return [{
          label: '序号',
          prop: 'id'
        }, {
          label: '巡检点',
          prop: 'name'
        },
        {
          label: '区域',
          prop: 'areaName'
        },
        {
          label: '巡检顺序',
          prop: 'sequence'
        }
      ]
    },
    config() {
      return [{
          prop: 'name',
          label: '预案名称'
        }, {
          prop: 'deptName',
          label: '巡检部门'
        }, {
          prop: 'max_time',
          label: '最长时长(小时)'
        }, {
          prop: 'min_time',
          label: '最短时长(小时)'
        }, {
          prop: 'interval_time',
          label: '间隔时间(分钟)'
        }, {
          prop: (row, column) => row.sequence == 0 ? "是" : "否",
          label: '是否顺序巡检'
        }, {
          prop: 'points',
          label: '巡检点位数'
        }, {
          prop: 'userName',
          label: '创建人'
        }, {
          prop: 'create_time',
          label: '创建时间'
        },
        // ,{
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
  },
  methods: {
    reset_xjyazd(fn) {
      fn();
      this.form_xjyazd = {};
      this.$refs['searchCompany'].company = '';
    },
    search_xjyazd(fn) {
      fn();
    },
    add() {
      this.addDialogVisible = true;
    },
    closeAdd() {
      this.addDialogVisible = false;
    },
    success() {
      this.addDialogVisible = false;
      this.$refs['table_xjyazd'].getData();
    },
    look(data) {
      this.lookLoading = true;
      this.lookDialogVisible = true;
      this.$axiosget('operation/plan/findInfo', {
        params: {
          id: data.id
        }
      }).then(res => {
        this.oLook = res.data.data;
        this.lookLoading = false;
      })
    },
    changeCompany(dept_id) {
      this.$set(this.form_xjyazd, "dept_id", dept_id);
    },
    deleteMsg(index, row) {
      this.$confirm("确定删除预案?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("/operation/plan/delete", {
            params: {
              "id": row.id
            }
          })
          .then(res => {
            this.$message({
              duration: 1000,
              message: '删除成功',
              type: 'success'
            });
            this.$refs['table_xjyazd'].getData();
          })
      }).catch(()=>{

      })
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    add: () => import("./add"),
    searchCompany: () => import("public/searchCompany")
  },
  mounted() {

    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });

    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom:1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/xunjian/xunjianPreArranged/index.vue